
define('css!ui/resource/css/selector',[],function(){});
